import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createSettings } from '../../Repositories/settings/settings';

const settingsObj = createSettings();

export function useGetColorCode(options) {
  return useQuery(['colorCodes'], () => settingsObj.getHrThemeColors(), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: (error) => {
      if (
        error?.status === 403 &&
        error?.message ===
          'Unable to get OAuth token for calendar. Please enable calendar services.'
      )
        return false;
      return true;
    },
    ...options,
  });
}

export function useColorCodePutSetting(options) {
  const queryClient = useQueryClient();
  return useMutation(['colorCodePutConfig'], (args) => settingsObj.putHrColorSettings(args), {
    onSuccess: () => {
      queryClient.invalidateQueries(['getColorCodeMapping']);
    },
    ...options,
  });
}

export function useGetColorCodeMapping(options) {
  return useQuery(['getColorCodeMapping'], () => settingsObj.getHrColorCodeMapping(), {
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    ...options,
  });
}

export function usePostHrColorSetting(options) {
  const queryClient = useQueryClient();
  return useMutation(['colorCodePostConfig'], (args) => settingsObj.postHrColorSettings(args), {
    onSuccess: () => {
      queryClient.invalidateQueries(['getColorCodeMapping']);
    },
    ...options,
  });
}
export function userDeleteColorMapping(options) {
  const queryClient = useQueryClient();
  return useMutation(
    ['colorCodeDeleteConfig'],
    (args) => settingsObj.deleteHrColorCodeMapping(args),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getColorCodeMapping']);
      },
      ...options,
    }
  );
}
